import * as types from '../constants/action-types';
import { getWebEnv, getAddOnsCategories, getSpaces, getActivities } from '../../../../api/api-env';
import SharedIntlProviderHOC from 'shared-components/hocs/sharedIntlProviderHOC';

export function resetEnvStore () {
  return {
    type: types.RESET_ENV_STORE
  };
}

export function fetchEnvRequest () {
  return {
    type: types.ENV_FETCH_REQUEST
  };
}

export function fetchEnvSuccess (web) {
  return {
    type: types.ENV_FETCH_SUCCESS,
    web
  };
}

function fetchEnvFailure (error) {
  return {
    type: types.ENV_FETCH_FAILURE,
    error
  };
}

export function fetchEnvWeb (query, callback) {
  const locale = SharedIntlProviderHOC.getLocale();
  return dispatch => {
    dispatch(fetchEnvRequest());
    getWebEnv(locale, (response) => {
      if (callback) {
        callback(response);
      }

      if (response.error) {
        return dispatch(fetchEnvFailure(response.error));
      }
      return dispatch(fetchEnvSuccess(response));
    }, query);
  };
}

export function fetchEnvAddOnsRequest () {
  return {
    type: types.ENV_ADDONS_FETCH_REQUEST
  };
}

export function fetchEnvAddOnsSuccess (addOns) {
  return {
    type: types.ENV_ADDONS_FETCH_SUCCESS,
    addOns
  };
}

export function fetchEnvAddOnsFailure (error) {
  return {
    type: types.ENV_ADDONS_FETCH_FAILURE,
    error
  };
}

export function fetchEnvAddOns () {
  return dispatch => {
    dispatch(fetchEnvAddOnsRequest());
    const locale = SharedIntlProviderHOC.getLocale();
    getAddOnsCategories(locale, (response) => {
      if (response.error) {
        return dispatch(fetchEnvAddOnsFailure(response));
      }
      return dispatch(fetchEnvAddOnsSuccess(response));
    });
  };
}

export function fetchEnvSpacesRequest () {
  return {
    type: types.ENV_SPACES_FETCH_REQUEST
  };
}

export function fetchEnvSpacesSuccess (spaces) {
  return {
    type: types.ENV_SPACES_FETCH_SUCCESS,
    spaces
  };
}

export function fetchEnvSpacesFailure (error) {
  return {
    type: types.ENV_SPACES_FETCH_FAILURE,
    error
  };
}

export function fetchEnvSpaces () {
  const locale = SharedIntlProviderHOC.getLocale();

  return dispatch => {
    dispatch(fetchEnvSpacesRequest());

    getSpaces(locale, (response) => {
      if (response.error) {
        return dispatch(fetchEnvSpacesFailure(response));
      }
      return dispatch(fetchEnvSpacesSuccess(response));
    });
  };
}

export function fetchEnvActivitiesRequest() {
  return {
    type: types.ENV_ACTIVITIES_FETCH_REQUEST
  };
}

export function fetchEnvActivitiesSuccess(activities) {
  return {
    type: types.ENV_ACTIVITIES_FETCH_SUCCESS,
    activities
  };
}

export function fetchEnvActivitiesFailure(error) {
  return {
    type: types.ENV_ACTIVITIES_FETCH_FAILURE,
    error
  };
}

export function fetchEnvActivities() {
  const locale = SharedIntlProviderHOC.getLocale();

  return (dispatch) => {
    dispatch(fetchEnvActivitiesRequest());

    getActivities(locale, (response) => {
      if (response.error) {
        return dispatch(fetchEnvActivitiesFailure(response));
      }
      return dispatch(fetchEnvActivitiesSuccess(response.response));
    });
  };
}
